import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["host", "textarea"]

    async connect() {
        const connection = this.connection = {}
        this.textareaTarget.classList.remove("hidden")
        this.onInput = () => this.textareaTarget.dispatchEvent(new Event("change", { bubbles: true }))
        this.textareaTarget.addEventListener("input", this.onInput)
        try {
            const { default: Editor } = await this.loadEditor()
            if (this.connection !== connection) return
            this.editor = new Editor({
                host: this.hostTarget,
                textarea: this.textareaTarget,
                placeholders: this.placeholdersValue,
                schema: this.schemaValue || {},
                readOnly: this.textareaTarget.readOnly,
            })
            this.textareaTarget.classList.add("hidden")
            this.dispatch("ready")
        } catch (error) {
            if (this.connection === connection) this.dispatch("error", { detail: { error } })
        }
    }

    get view() { return this.editor?.view }

    setContent(content, { readOnly = false } = {}) {
        this.textareaTarget.value = content
        this.textareaTarget.readOnly = readOnly
        this.editor?.setContent(content, { readOnly })
    }

    focus() {
        this.editor ? this.editor.focus() : this.textareaTarget.focus()
    }

    insertVariable(value) {
        if (this.editor) return this.editor.insertVariable(value)
        const textarea = this.textareaTarget
        textarea.setRangeText(value, textarea.selectionStart, textarea.selectionEnd, "end")
        textarea.dispatchEvent(new Event("change", { bubbles: true }))
        this.focus()
    }

    disconnect() {
        this.connection = null
        this.editor?.destroy()
        this.editor = null
        this.textareaTarget.removeEventListener("input", this.onInput)
        this.textareaTarget.classList.remove("hidden")
    }
}
